import React, { useState } from "react";
import WelcomeModal from "./Components/WelcomeModal";
import "../../../../Assets/Styles/UserGuide.scss";
import ImagePreloader from "../ShareElements/ImagePreloader/ImagePreloader";
import Dialog from "../../../../Assets/Images/Dialog.svg";
import Dialog2 from "../../../../Assets/Images/Dialog2.svg";
import Dialog3 from "../../../../Assets/Images/Dialog3.svg";
import Dialog4 from "../../../../Assets/Images/Dialog4.svg";
import Dialog5 from "../../../../Assets/Images/Dialog5.svg";
import Dialog6 from "../../../../Assets/Images/Dialog6.svg";
import Dialog7 from "../../../../Assets/Images/Dialog7.svg";

const UserGuide = (props) => {
  const [ModalIsOpen, setModalIsOpen] = useState(true);

  const startUserGuide = () => {
    if (props.HasAdditionalStep) {
      props.setAdminHomeGuideIsOpen(true);
    } else {
      props.setJPATabsGuideIsOpen(true);
    }
    setModalIsOpen(false);
  };

  return (
    <>
      <ImagePreloader
        Images={[Dialog, Dialog2, Dialog3, Dialog4, Dialog5, Dialog6, Dialog7]}
      />
      {ModalIsOpen ? (
        <div className="guide-overlay">
          <WelcomeModal
            Skip={() => props.Skip()}
            Start={() => startUserGuide()}
            LangData={props.LangData}
          />
        </div>
      ) : null}
    </>
  );
};

export default UserGuide;
